import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'pages.availabilityPage.title',
    description: 'Page title',
    defaultMessage: 'Edit Availability',
  },
  subTitle: {
    id: 'pages.availabilityPage.subTitle',
    description: 'Page sub title',
    defaultMessage:
      'These steps describe how to generate and access your authentication token in Calendly',
  },
  stepOne: {
    id: 'pages.availabilityPage.stepOne',
    description: 'Page step one',
    defaultMessage: '1. Log in to Calendly',
  },
  stepTwo: {
    id: 'pages.availabilityPage.stepTwo',
    description: 'Page step two',
    defaultMessage: '2. Navigate to the Integrations page',
  },
  stepThree: {
    id: 'pages.availabilityPage.stepThree',
    description: 'Page step three',
    defaultMessage: '3. Copy your API Key',
  },
  nextBtnLabel: {
    id: 'pages.availabilityPage.nextBtnLabel',
    description: 'Next button lable',
    defaultMessage: 'Next',
  },
  backBtnLabel: {
    id: 'pages.availabilityPage.backBtnLabel',
    description: 'Back button lable',
    defaultMessage: 'Back',
  },
  apiKeyDesc: {
    id: 'pages.availabilityPage.apiKeyDesc',
    defaultMessage: 'On the Integrations page, you will find your API Key!',
    description: 'API key step description',
  },
  apiKeyPlaceholder: {
    id: 'pages.availabilityPage.apiKeyPlaceholder',
    description: 'API key placeholder',
    defaultMessage: 'Enter your Calendly API key',
  },
  chooseEventType: {
    id: 'pages.availabilityPage.chooseEventType',
    description: 'Choose event type label',
    defaultMessage:
      'Please enter an amount of at least $0 and then click to select any appointment type which you wish to make available.',
  },
  saveBtnLabel: {
    id: 'pages.availabilityPage.saveBtnLabel',
    description: 'Save button lable',
    defaultMessage: 'Save',
  },
  editAppointmentTypesBtnLabel: {
    id: 'pages.availabilityPage.editAppointmentTypesBtnLabel',
    description: 'Edit Appointment Types button lable',
    defaultMessage: 'Edit Appointment Types',
  },
});
